import { PARAMETER_EVENT, WIDGET_CLASS_ATTRIBUTES } from "./constants";


export function activeIcon(value) {
    let activeIcon = document.querySelector(".activeIcon");
    activeIcon.style.display = value;
}

// Function for get readable Ten word //
export function getTenReadableInnerText(innerText) {
    let firstTenWords;
    if (innerText?.includes(WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING)) {
        innerText?.replace(WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING, " ");
    }
    let words = innerText?.match(/\b\w+\b/g);
    if (words && words.length > 0) {
        firstTenWords = words?.slice(0, 9)?.join(" ");
    }
    return firstTenWords;
}

//  Handle Numbers Convert to Words  //
export function numberToWords(num) {
    const belowTwenty = [
        'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
        'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'
    ];

    const tens = [
        '', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
    ];

    const hundreds = [
        '', 'hundred', 'thousand'
    ];

    if (num < 20) {
        return belowTwenty[num];
    }

    if (num < 100) {
        return tens[Math.floor(num / 10)] + (num % 10 === 0 ? '' : ' ' + belowTwenty[num % 10]);
    }

    if (num < 1000) {
        return belowTwenty[Math.floor(num / 100)] + ' ' + hundreds[1] + (num % 100 === 0 ? '' : ' and ' + numberToWords(num % 100));
    }

    if (num < 10000) {
        return belowTwenty[Math.floor(num / 1000)] + ' ' + hundreds[2] + (num % 1000 === 0 ? '' : ' ' + numberToWords(num % 1000));
    }

    return num;
}

 //  Check Length And Handle  //
 export function CheckAttributeLength(attribute) {
    let wordCount = attribute.split(/\s+/).length;
    if (wordCount > 10) {
        // console.log("1) Remove extra lengthy values. 2) Only 5 to 10 words:", attribute);
        if (attribute?.includes(WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING)) {
            attribute?.replace(WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING, " ");
        }
        return wordCount;
    } else if (wordCount < 1) {
        // console.log(`Use a meaningful readable ${attribute}:`);
        return wordCount;
    }
}

// Structure Change With Style and Events //
export function structureChangeWithStyle(element, newElement) {

    if (!element || !element.parentNode) {
        console.error('Cannot replace element. The element does not have a parent node.', element);
        return;
    }

    const newTag = document.createElement(newElement);
    newTag.innerHTML = element.innerHTML;
    const computedStyles = window.getComputedStyle(element);

    // Transfer all computed styles
    for (let property of computedStyles) {
        newTag.style[property] = computedStyles.getPropertyValue(property);
    }

    // Transfer all attributes
    for (let attr of element.attributes) {
        newTag.setAttribute(attr.name, attr.value);
    }

    // Transfer events if possible

    // Check if event listeners are attached
    const events = ['click', 'dblclick', 'mousedown', 'mouseup', 'mouseenter', 'mouseleave', 'mouseover', 'mouseout', 'keydown', 'keypress', 'keyup', 'focus', 'blur', 'change', 'input', 'submit', 'reset', 'resize', 'scroll', 'contextmenu'];
    let eventAttached = false;

    events.forEach((event) => {
        if (element[`on${event}`] !== null) {
            // console.log(`Element "${event}" event listener attached.`, element);
            // console.error('Please change this element Sructure hardcoded:', element);
            eventAttached = true;
        }
    });

    if (!eventAttached) {
        // console.log('Element not attached event listener.', element);
        // Replace `b` with `strong`
        return element.replaceWith(newTag);
    }
}



function filterNone() {
    return NodeFilter.FILTER_ACCEPT;
}
export function getAllComments(rootElem) {
    var comments = [];
    var iterator = document.createNodeIterator(
        rootElem,
        NodeFilter.SHOW_COMMENT,
        filterNone,
        false
    );
    var curNode;
    while ((curNode = iterator.nextNode())) {
        comments.push(curNode.nodeValue.trim());
    }
    return comments;
}